import React, { useEffect, memo, useState, useRef } from 'react';
import './index.less';
import { ExamPointDetailAnalysis, ExamPointsRightArrowIcon } from '@/svgs';
import { useAppStore } from '@/store';
import { IPredictionScoreExamPointDetail } from '@/types';
import globalStore from '@/store/global';

interface IProps {
    detailData: IPredictionScoreExamPointDetail;
}

const ExamPointAnalysis = ({ detailData }: IProps) => {
    const {
        themeStore: { theme },
    } = useAppStore();

    return (
        <div
            className="sub-tiku__exam-point-analysis"
            onClick={() => {
                if (!detailData.knowledgeId) return;
                globalStore.publish('main-app', {
                    type: 'gotoAnalysis',
                });
            }}
        >
            <div className="sub-tiku__status-icon">
                <ExamPointDetailAnalysis color={theme.mainColor} />
            </div>
            <div className="sub-tiku__exam-point-analysis-content">查看解析</div>
            <div className="sub-tiku__mr-auto"></div>
            <ExamPointsRightArrowIcon />
        </div>
    );
};

export default memo(ExamPointAnalysis);
